module.exports = __webpack_public_path__ + "img/contact.9fea5f8.png";